import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProductService } from 'src/app/service/product.service';
import { Product } from 'src/app/types/types';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styles: [
  ]
})
export class SearchComponent implements OnInit {

  products : Product[] = [];
  searchValue : string = "";

  constructor(
    private productService :ProductService,
    private activatedRouter : ActivatedRoute,

  ) {
    activatedRouter.params.subscribe(data => this.searchValue = data.value)
    this.products = productService.searchBy(this.searchValue) ;
    console.log("Este")
    console.log(this.products)
   }

  ngOnInit(): void {
  }

}
